import $ from 'jquery';

import magnificPopup from 'magnific-popup';

var body = $('body, html');

$( document ).ready(function() {
    handleJobPopup();
    handleJobPopupEdits();
});

function handleJobPopup() {
    if ($('.open-popup').length) {
        $('.open-popup').magnificPopup({
            items: {
                src: $('.job-popup'),
                type: 'inline',
                closeOnBgClick: true,
                fixedContentPos: false,
                autoFocusLast: false,
                closeBtnInside: true,    
                mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                fixedContentPos: true,
            },
    
            callbacks: {
            open: function() {
                jQuery('body, html').addClass('noscroll');
    
            },
            close: function() {
                jQuery('body, html').removeClass('noscroll');
            }
            }
    
        });
        $('.mfp-close').on('click', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        })
    }
}

function handleJobPopupEdits() {
    var url = 'https://boards-api.greenhouse.io/v1/boards/dianthustherapeutics/departments';
    var myvar = null;
    $.ajax({
        url: url,
        type: 'GET',
        async: false,
        success: function(data){
            myvar = data;
        }
    });

    $.each( myvar['departments'], function() {
        if($(this)[0].jobs.length != 0) {
            
            var y = myvar['departments'].length;
            var dep = [];
            for (var i = 0; i < y; i++) {
                dep.push(myvar['departments'][i].id, myvar['departments'][i].name);
            }
            $.each($(this), function() {
                var x = $(this)[0].jobs.length;
                var p = $(this)[0].parent_id;
                var name = $(this)[0].name;
                var next;

                if( p != null ) {
                    next = dep[($.inArray(p, dep)) % dep.length + 1];
                }
                
                if($(this)[0].name === 'Regulatory Affairs') {
                    name = '';
                }

                $('<div class="job-department has-turquoise-color h4--bigger font-weight-bold">' + name + '</div>').appendTo($('.job-popup__jobs'));
                for (var i = 0; i< x; i++) {
                    $('<a class="job-job" href="' + $(this)[0].jobs[i].absolute_url + '" target="_blank"><div class="h4 has-purple-color mb-0">' + $(this)[0].jobs[i].title + '</div></a>').appendTo($('.job-popup__jobs'));
                    $('<div class="job-location mb-5 has-purple-color p"> ' + $(this)[0].jobs[i].location.name + '</div>').appendTo($('.job-popup__jobs'));
                }
            })
        }
    });
    setTimeout(function() {
        $('.job-popup').find('.jobs').find('.job').each(function() {
            var location = $(this).attr('data-locations'),
                department = $(this).attr('data-departments');
            department = department.split(':')[0];

            $(this).addClass('mb-5');
            $(this).find('h2').addClass('h4 has-purple-color mb-0');
            $(this).children('p').remove();
            $(this).children('.job_description').remove();
            $(this).prepend( "<a class='job_url' href='https://boards.greenhouse.io/dianthustherapeutics/jobs/" + $(this).attr('data-id') + "' target='_blank'>" );
            $(this).append( "</a>" );
            $("<div class='job_department has-turquoise-color h4--bigger font-weight-bold'>" + department + "</div>").insertBefore($(this).find('a.job_url'));
            $(this).find('h2').prependTo($(this).find("a.job_url"));
            $(this).append( "<div class='job_location has-purple-color p'>" + location + "</div>" );

            $(this).find('a.job_apply_' + $(this).attr('data-id')).unbind("click").bind('click', function(e) {
                e.preventDefault();
                $(this).removeClass('open');
                var url = $(this).attr('href'); 
                window.open(url, '_blank');
            });
        });
    }, 200);
}